// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_zDv","cls2":"BulkFollowSuggestion-cls2_Q8J BulkFollowSuggestion-cls1_zDv"};